import { defineMessages } from 'react-intl';

export default defineMessages({

    title: {
        id: 'qnb.common.title',
        defaultMessage: 'What is {possessivePronoun} title?'
    },
    firstName: {
        id: 'qnb.common.firstName',
        defaultMessage: 'What is {possessivePronoun} first name?'
    },
    lastName: {
        id: 'qnb.common.lastName',
        defaultMessage: 'What is {possessivePronoun} surname?'
    },
    gender: {
        id: 'qnb.common.gender',
        defaultMessage: 'Gender'
    },
    readOnlyNameHeader: {
        id: 'qnb.common.readOnlyNameHeader',
        defaultMessage: 'Full name'
    }
});
